﻿import angular from 'angular';

import './api/orders';

angular.module('folkeuni').factory('ResponsiveBackgroundImage',function($q,$timeout){
    var reponsiveImageService = this;
    var ribbonRatio = 4.7575;
    var windowWidth = 0;

    reponsiveImageService.debounce = function(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    var resizeDebouncer = reponsiveImageService.debounce(function(){
        reponsiveImageService.changeResponsiveImage();
    }, 100);
 
    reponsiveImageService.changeResponsiveImage = function() {
        var viewport = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

        this.windowWidth = viewport;

        if (viewport > 1100) {
            reponsiveImageService.responsiveImageSwitcher("background-image-xlarge");
        }
        else if (viewport > 768) {
            reponsiveImageService.responsiveImageSwitcher("background-image-large");
        }
        else if (viewport > 480) {
            reponsiveImageService.responsiveImageSwitcher("background-image-medium");
        }
        else {
            reponsiveImageService.responsiveImageSwitcher("background-image-small");
        }
    }

    reponsiveImageService.responsiveImageSwitcher = function(imgAttr) {
        var smallBGs = document.querySelectorAll('*[' + imgAttr + ']');

        for (var i = 0; i < smallBGs.length; i++) {
            var currentElement = smallBGs[i];
            var targeSrc = currentElement.getAttribute(imgAttr);
            currentElement.style.backgroundImage = "url('" + targeSrc + "\')";
            if (currentElement.getAttribute("class").indexOf('no-content') > -1) {
                    currentElement.style.height = String(windowWidth / ribbonRatio) + "px";
            }
        }
    }

    reponsiveImageService.initialize = function() {
        $timeout(function(){reponsiveImageService.changeResponsiveImage()},250);
        window.addEventListener('resize', resizeDebouncer);
    }

    return reponsiveImageService;
   
});

